import { factory, detectPrng } from 'ulid'

const prng = detectPrng(true) // pass `true` to allow insecure Math.rand
const ulid = factory(prng)

interface AnalyticsConfig {
  bodyParams: any
  client: (endpoint: string, params: any) => void
  endpoint: string
  headers: Object
}

export default class Analytics {
  bodyParams: any
  client: (endpoint: string, params: any) => void
  endpoint: string
  headers: Object

  constructor({ bodyParams, client, endpoint, headers }: AnalyticsConfig) {
    this.endpoint = endpoint
    this.headers = headers
    this.bodyParams = bodyParams
    this.client = client
    this.trackEvent = this.trackEvent.bind(this)
  }

  trackEvent(event: any, properties: any) {
    const time = new Date()
    return this.client(this.endpoint, {
      method: 'POST',
      header: this.headers,
      body: JSON.stringify({
        key: event,
        properties,
        timestamp: time,
        event_id: ulid(),
        page_id: ulid(),
        ...this.bodyParams,
      }),
    })
  }
}
